import React from 'react';
import { Link } from 'react-router-dom';
import { machines } from '../data/MachinesData.js';
import './MachinesPage.css';

const MachinesPage = () => {
  return (
    <div className="machines-container">
      <h1>Galerie des Machines</h1>
      <p>Cliquez sur l'une des machines ci-dessous pour en savoir plus.</p>
      <div className="machines-grid">
        {machines.map((machine) => (
          <Link
            key={machine.id}
            to={`/machines/${machine.id}`}
            className="steampunk-button"
            style={{ textDecoration: 'none' }}
          >
            {machine.name}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MachinesPage;